import React from 'react';

function BaseProjectManufacturingPlaning() {
  return <div>BaseProjectManufacturingPlaning</div>;
}

export default BaseProjectManufacturingPlaning;
